import { Setting } from "@/models/setting";
import axiosGlobal from "@/main";

export default {
  async getSettings(): Promise<Setting[]> {
    try {
      const response = await axiosGlobal.get<Setting[]>(`/api/setting`);
      const settings: Setting[] = response.data;
      return settings;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },

  async getSetting(name: string): Promise<Setting | null> {
    try {
      const response = await axiosGlobal.get<Setting>(`/api/setting/` + name);
      const settings: Setting = response.data;
      return settings;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },

  async getSettingValue(name: string): Promise<any | null> {
    try {
      const response = await axiosGlobal.get<Setting>(`/api/setting/` + name);
      return response.data;
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },

  async setSetting(setting: Setting): Promise<Setting> {
    await axiosGlobal.post(`/api/setting/set`, setting, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return setting;
  },

  async delete(id: string): Promise<void> {
    try {
      await axiosGlobal.delete<Setting>(`/api/setting/delete/` + id);
    } catch (error) {
      console.error("Error occurred:", error);
      throw error;
    }
  },
};
